import { PencilAltIcon, TrashIcon } from "@heroicons/react/solid";
import AddLeaveTypeModal from "../../components/companySettings/AddLeaveTypeModal";
import { Button } from "../../components/ui";
import useLeaveStructureSettings from "../../hooks/companySettings/useLeaveStructureSettings";
import EditLeaveTypeModal from "../../components/companySettings/EditLeaveTypeModal";
import Cookies from "universal-cookie";
import { COMPANY_ID } from "../../config";
import Pagination from "../../components/pagination";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import RoundedContainer from "../../components/containers/RoundedContainer";
import SearchBar from "../../components/inputs/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const cookies = new Cookies();

const LeaveStructure = () => {
  const companyId = cookies.get(COMPANY_ID);

  const {
    handleCreateLeaveType,
    handleUpdateLeaveType,
    openAddModal,
    closeAddModal,
    openEditModal,
    closeEditModal,
    searchLeaveType,
    handlePageClick,
    closeDeleteConfirmation,
    handleDeleteType,
    openDeleteConfirmation,
    searchQuery,
    showDeleteConfirmation,
    leavesData,
    isAddModalOpen,
    isEditModalOpen,
    editData,
    isLoading,
  } = useLeaveStructureSettings({ companyId: companyId });
  const breadcrumbs = [
    {
      label: "Company Settings",
      link: "/company-settings",
    },
    {
      label: "Leave Structure",
      link: "",
    },
  ];

  return (
    <>
      {/* Add leave type modal */}
      {isAddModalOpen && (
        <AddLeaveTypeModal
          isOpen={isAddModalOpen}
          onClose={closeAddModal}
          handleCreateLeaveType={handleCreateLeaveType}
        />
      )}
      {/* Edit leave type modal */}
      {isEditModalOpen && (
        <EditLeaveTypeModal
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          handleUpdateLeaveType={handleUpdateLeaveType}
          editData={editData}
        />
      )}

      {showDeleteConfirmation && (
        <ConfirmationModal
          isOpen={showDeleteConfirmation}
          onClose={closeDeleteConfirmation}
          title={"Delete Leave Type?"}
          description={"Are you sure you want to delete this leave type?"}
          onConfirm={handleDeleteType}
          confirmButtonLabel={"Delete"}
        />
      )}

      <div className="px-4 py-5">
        <BreadCrumbs crumbs={breadcrumbs} />
        <h1 className=" text-xl font-bold mb-4 mt-4">Leave Structure</h1>
        <RoundedContainer className="flex justify-between">
          <SearchBar
            className={"w-80"}
            value={searchQuery}
            onChange={(e) => searchLeaveType(e.target.value)}
          />

          <Button onClick={openAddModal}>Add leave type</Button>
        </RoundedContainer>

        <RoundedContainer>
          {isLoading ? (
            <div className="flex justify-center items-center h-40">
              <div className="loader"></div>
              <p className="ml-6">Loading...</p>
            </div>
          ) : !leavesData?.data?.length ? (
            <div className="text-center py-12">
              <p className="text-gray-700 text-2xl font-semibold mb-2">No Leave Structure To Show</p>
              <p className="text-gray-500 text-sm mb-5">Configure leave types (e.g. Casual Leave, Sick Leave) for your employees.</p>
              <Button onClick={openAddModal}>Add Leave Type</Button>
            </div>
          ) : (
            <Table className="table-auto w-full">
              <TableHead>
                <TableHeaderCell className="w-[45%]">
                  Name
                </TableHeaderCell>
                <TableHeaderCell className="w-[35%] text-center">
                  Is document required?
                </TableHeaderCell>
                <TableHeaderCell className="w-[20%] text-center">
                  Actions
                </TableHeaderCell>
              </TableHead>
              <TableBody>
                {leavesData?.data?.map((el, index) => {
                  const {
                    is_document_required,
                    delete_applicable,
                    leave_head_name,
                  } = el;
                  return (
                    <TableRow key={index}>
                      <TableCell className="text-dark font-medium text-sm">
                        {leave_head_name}
                      </TableCell>
                      <TableCell className="text-center text-dark font-medium text-sm">
                        {is_document_required ? "Yes" : "No"}
                      </TableCell>
                      <TableCell className="text-center text-dark font-medium text-sm">
                        <div className="flex justify-center items-center space-x-2">
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            onClick={() => openEditModal(el)}
                          >
                            <PencilAltIcon className="text-gray-500 w-5 h-5 hover:text-primary transition-colors" />
                          </Button>
                          {delete_applicable ? (
                            <Button onClick={() => openDeleteConfirmation(el)} variant={"ghost"} size={"icon"}>
                              <TrashIcon className="text-gray-500 w-5 h-5 hover:text-red-600 transition-colors cursor-pointer" />
                            </Button>
                          ) : (
                            <div className="w-8 h-8"></div>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </RoundedContainer>

        {!!leavesData?.data?.length && (
          <RoundedContainer className="mt-4">
            <Pagination
              currentPage={leavesData?.page_no}
              lengthofItems={+leavesData?.total_count}
              limit={leavesData?.per_page}
              onPageChange={handlePageClick}
            />
          </RoundedContainer>
        )}
      </div>
    </>
  );
};

export default LeaveStructure;
